import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Guide from '../views/Guide.vue'
import Exhibition from '../views/Exhibition.vue'
import Articles from '../views/Articles.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      hideNavbar: true
    }
  },
  {
    path: '/exposicion',
    name: 'Exhibition',
    component: Exhibition,
    meta: {
      hideNavbar: true
    }
  },
  {
    path: '/libros/:category',
    name: 'Books',
    props: true,
    // lazy-loaded javascript chunk
    component: () => import('../views/Works.vue')
  },
  {
    path: '/articulos',
    name: 'Articles',
    component: Articles
  },
  {
    path: '/sala',
    name: 'Guide',
    component: Guide,
    meta: {
      hideNavbar: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
